exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.h-full {\n  height: 100%;\n}\n", "", {"version":3,"sources":["E:/Projs/pkushare/projs/PKU_ancn/code/gx_frontend_skqs/src/view/read/index.vue"],"names":[],"mappings":";AACA;EACE,aAAa;CACd","file":"index.vue","sourcesContent":["\n.h-full {\n  height: 100%;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-27a8aab2","scoped":false,"hasInlineConfig":false}!./node_modules/less-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/view/read/index.vue
// module id = FY46
// module chunks = 2